var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconContact01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 129,
    viewBox: "0 0 104 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dot",
    clipPath: "url(#clip0_885_31272)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M71.1 126.9C74.0602 126.9 76.46 124.5 76.46 121.54C76.46 118.579 74.0602 116.18 71.1 116.18C68.1397 116.18 65.74 118.579 65.74 121.54C65.74 124.5 68.1397 126.9 71.1 126.9Z",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M42.1 12.1302C45.0602 12.1302 47.46 9.7304 47.46 6.77016C47.46 3.80991 45.0602 1.41016 42.1 1.41016C39.1397 1.41016 36.74 3.80991 36.74 6.77016C36.74 9.7304 39.1397 12.1302 42.1 12.1302Z",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M55.33 20.5195C58.07 20.5195 58.07 16.2695 55.33 16.2695C52.59 16.2695 52.59 20.5195 55.33 20.5195Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M100.99 82.9883C103.73 82.9883 103.73 78.7383 100.99 78.7383C98.25 78.7383 98.25 82.9883 100.99 82.9883Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M47.45 54.9805C50.19 54.9805 50.19 50.7305 47.45 50.7305C44.71 50.7305 44.71 54.9805 47.45 54.9805Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M2.05 126.539C4.79 126.539 4.79 122.289 2.05 122.289C-0.690005 122.289 -0.690005 126.539 2.05 126.539Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M18.37 36.5586C21.11 36.5586 21.11 32.3086 18.37 32.3086C15.63 32.3086 15.63 36.5586 18.37 36.5586Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M24.31 48.0898C27.05 48.0898 27.05 43.8398 24.31 43.8398C21.57 43.8398 21.57 48.0898 24.31 48.0898Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M97.3 34.4995C99.81 37.0095 100.93 40.5895 100.29 44.0795C98.68 52.9695 92.94 70.8295 72.56 91.2095C52.18 111.59 34.31 117.33 25.43 118.94C21.93 119.57 18.36 118.46 15.85 115.95L3.47 103.57C1.6 101.7 1.6 98.6595 3.47 96.7895L16.73 83.5295C18.33 81.9295 20.83 81.6695 22.72 82.8895L43.02 96.0095L77.37 61.6595L64.25 41.3595C63.02 39.4595 63.29 36.9595 64.89 35.3695L78.15 22.1095C80.02 20.2395 83.06 20.2395 84.93 22.1095L97.31 34.4895L97.3 34.4995Z",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_885_31272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103.04,
    height: 128.31,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContact01);
export default __webpack_public_path__ + "static/media/icon_contact_01.1995e4de833342a328103005d2dac4ca.svg";
export { ForwardRef as ReactComponent };